import Vue from 'vue';
import VueNotifications from 'vue-notifications';

// Vue toasted specfic
import Toasted from 'vue-toasted';

const toastedDefaults = {
    iconPack: 'fontawesome',
    position: 'top-right',
    className: 'ca-notification',
};

Vue.use(Toasted, toastedDefaults);

// Register cutom taosted config
const customToastOptions = ({ router, media }) => {
    return {
        success: {
            type: 'success',
            icon: 'thumbs-up',
        },
        error: {
            type: 'error',
            icon: 'bomb',
        },
        info: {
            type: 'info',
            icon: 'info',
        },
        warn: {
            type: 'warn',
            icon: 'exclamation',
        },
        media: {
            type: 'info',
            className: 'is-media',
            iconPack: 'callback',
            icon(el) {
                if (media.hasThumbnail) {
                    const img = new Image();
                    img.src = media.thumbnail({ w: 100, h: null });
                    el.appendChild(img);
                }
                return el;
            },
            action: [
                media && media.canView
                    ? {
                          text: 'View',
                          onClick: (e, toastObject) => {
                              if (router) {
                                  const name = media.isBeforeAfter ? 'edit' : 'view';
                                  router.push({ name, params: { id: media.id } });
                                  toastObject.goAway(0);
                              } else {
                                  const name = media.isBeforeAfter ? 'media.edit' : 'media.view';
                                  window.location.href = route(name, [ca.client.base_url, ca.project.slug, media.id]);
                              }
                          },
                      }
                    : {
                          text: 'Download',
                          onClick: (e, toastObject) => {
                              const link = document.createElement('a');
                              link.href = `${media.url}?p=download`;
                              link.click();
                          },
                      },
            ],
        },
    };
};

// actual notify function can replace return value with other librarries
const notify = ({ type, message, icon, timeout, actions, router, media, showClose, cb }) => {
    const customOptions = customToastOptions({ router, media });

    // append className if in options
    const hasClassName =
        customOptions.hasOwnProperty(type) &&
        customOptions[type].hasOwnProperty('className') &&
        customOptions[type].className;

    // Setup options
    if (hasClassName) customOptions[type].className = `${toastedDefaults.className} ${customOptions[type].className}`;

    const options = customOptions.hasOwnProperty(type) ? customOptions[type] : {};

    if (icon) options.icon = icon;
    if (timeout) options.duration = timeout;
    if (cb) options.onComplete = cb;
    if (actions) options.action = actions;
    if (showClose) {
        const closeAction = {
            text: 'Close',
            onClick: (e, toastObject) => {
                toastObject.goAway(0);
            },
        };

        if (options.action) {
            options.action.push(closeAction);
        } else {
            options.action = [closeAction];
        }
    }

    // Register custom toasted
    Vue.toasted.register(type, message, options);

    // Call toasted
    return Vue.toasted.global[type]({ message });
};
// end Vue toasted specfic

Vue.use(VueNotifications, {
    success: notify,
    error: notify,
    info: notify,
    warn: notify,
});

export default notify;
